import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, withLatestFrom, filter, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Action, Store } from '@ngrx/store';

import { BckpConstants } from '@apps/bckp/bckp.constants';
import { CopyEvolution } from '@apps/bckp/domain/models';
import { IAuroraState } from '@apps/aurora.state';
import {
    getCopiesEvolQueryString,
    getCopiesEvolIsDataValid,
    getBckpCopiesEvolFilter
} from '../../bckp-copies.reducer';
import { CopyMiscDomainService } from '@apps/bckp/domain';
import * as fromCopiesEvolActions from './evol.actions';
import { NotfGravity, NotificationService, NotifType } from '@common/services';


@Injectable({
    providedIn: 'root'
})
export class BckpCopiesEvolEffects
{
    constructor (
        private actions: Actions,
        private copyMiscDomainService: CopyMiscDomainService,
        private store: Store<IAuroraState>,
        private notificationService: NotificationService
    )
    {
    }

    bckpCopiesEvolODataRequested: Observable<Action> = createEffect(() =>
        this.actions.pipe(
            ofType(fromCopiesEvolActions.BckpCopiesEvolODataRequested),
            withLatestFrom(
                this.store.select(getCopiesEvolQueryString),
                this.store.select(getCopiesEvolIsDataValid),
                this.store.select(getBckpCopiesEvolFilter),
                (_, qs, isDataValid, filter) => ({
                    qs,
                    isDataValid,
                    filter
                })
            ),
            filter(({ isDataValid }) => !isDataValid),
            switchMap(({ qs, filter }) =>
                this.copyMiscDomainService.getCopiesEvolutionPerMSDP(qs, filter.rangeSince, filter.rangeUntil)
                    .pipe(
                        map((copies: CopyEvolution[]) =>
                            fromCopiesEvolActions.BckpCopiesEvolODataSucceeded({ copies })
                        ),
                        catchError(() =>
                            of(fromCopiesEvolActions.BckpCopiesEvolODataFailed())
                        )
                    )
            )
        )
    );

    bckpCopiesEvolODataFailed = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromCopiesEvolActions.BckpCopiesEvolODataFailed),
                    tap(() =>
                        this.notificationService.notify(
                            [
                                'BACKUP.COPIES.EVOL.NOTF.GRAPH.TITLE',
                                'BACKUP.COPIES.EVOL.NOTF.GRAPH.MSGFAILED'
                            ],
                            NotfGravity.danger,
                            NotifType.SNACKBAR
                        )
                    )
                ),
        { dispatch: false }
    );

    bckpCopiesFilterApplied = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromCopiesEvolActions.BckpCopiesEvolFilterApplied),
                    tap((params: any) =>
                    {
                        this.store.dispatch(fromCopiesEvolActions.BckpCopiesEvolCleared());
                        this.store.dispatch(fromCopiesEvolActions.BckpCopiesEvolODataInitialized({
                            scrollSize: BckpConstants.QSCopiesTop,
                            filter: params.filter
                        }));
                    }),
                    tap(() =>
                        this.store.dispatch(fromCopiesEvolActions.BckpCopiesEvolODataRequested())
                    )
                ),
        { dispatch: false }
    );

}
